import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { AlertTriangle, CreditCard } from 'lucide-react';

export default function SubscriptionWall() {
  const { subscription, user } = useAuth();
  const navigate = useNavigate();

  // Don't show for super_admin or if no subscription data
  if (!subscription || user?.role === 'super_admin') return null;

  // Don't show if trial not expired or has paid plan
  if (!subscription.trial_expired || subscription.plan !== 'trial') return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" data-testid="subscription-wall">
      <div className="bg-card border border-border rounded-xl shadow-2xl max-w-md w-full p-8 text-center space-y-5 animate-fade-in">
        <div className="w-16 h-16 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mx-auto">
          <AlertTriangle className="w-8 h-8 text-amber-600" />
        </div>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground">Free Trial Expired</h2>
          <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
            Your free trial has ended. Subscribe to a plan to continue using VoyageOS and manage your travel business.
          </p>
        </div>
        <div className="space-y-2">
          <Button
            onClick={() => navigate('/dashboard/billing')}
            className="w-full gap-2 bg-voyage-blue hover:bg-voyage-blue-dark text-white h-11"
            data-testid="subscribe-now-btn"
          >
            <CreditCard className="w-4 h-4" /> View Plans & Subscribe
          </Button>
          <p className="text-xs text-muted-foreground">Plans start at INR 999/month</p>
        </div>
      </div>
    </div>
  );
}
